// extracted by mini-css-extract-plugin
export var menu = "Menu-module--menu--3qiBi";
export var link = "Menu-module--link--1QoRD";
export var container = "Menu-module--container--1VgYO";
export var title = "Menu-module--title--1F2Ll";
export var par = "Menu-module--par--2g7xt";
export var button = "Menu-module--button--2Iyoi";